import React, { useMemo } from "react";
import "@mui/material";
import { StyledTooltip } from "../../tooltip/Tooltip.js";
import "moment-timezone";
import "react-intl";
import "../../label/EmptyLabel.js";
import "../../label/LabelHoc.js";
import "../../tooltip/AutoAdjustedWidthTooltip.styles.js";
import "../../tooltip/AutoAdjustedComplexTooltip.styles.js";
import "../../tooltip/MultiLineAutoAdjustedWidthTooltip.js";
function GlideGridTooltip({ bounds, value, children }) {
  const anchorEl = useMemo(() => {
    const height = bounds?.height ? bounds.height - 15 : 0;
    return value && bounds ? {
      nodeType: 1,
      getBoundingClientRect: () => ({
        x: bounds.x,
        y: bounds.y,
        width: bounds.width,
        height,
        top: bounds.y,
        left: bounds.x,
        right: bounds.x + bounds.width,
        bottom: bounds.y + height,
        toJSON: () => ""
      })
    } : null;
  }, [bounds, value]);
  return /* @__PURE__ */ React.createElement(
    StyledTooltip,
    {
      element: /* @__PURE__ */ React.createElement(React.Fragment, null, children),
      title: value,
      slotProps: {
        popper: (props) => ({
          ...props,
          anchorEl,
          open: Boolean(value)
        })
      }
    }
  );
}
export {
  GlideGridTooltip
};
//# sourceMappingURL=GlideGridTooltip.js.map
